module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMBAMAAACkW0HUAAAAGFBMVEU3h8g4iMkzkMwxjM40i8sRVaI6icocZq1A18hNAAAABXRSTlPf3R4fHaUUY0AAAAAfSURBVAjXY3BMAwImBvZQIChkSAVRYSRTMO2KIMOYAeaTF6hj6QH1AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/check.png
// module id = M7DX
// module chunks = 1